import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import * as Icon from "react-feather";

const ProfileDropDownStyle = styled.div`
  position: absolute;
  top: 50px;
  right: 0;
  background: #fff;
  z-index: 50;
  width: fit-content;
  min-width: 300px;

  .arrow {
    position: absolute;
    z-index: 1;
    top: -10px;
    right: 10px;
    width: 25px;
    height: 25px;
    transform: rotate(45deg);
  }

  li.hoverable {
    &:hover {
      background: #eee;
      color: #442ed0;
    }
  }

  li {
    list-style-type: none;
  }
`;

const ProfileDropDown = ({ toggleDropDown, org }) => {
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // If click is outside dropdown and not on toggle button
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !event.target.closest(".dropdown-toggle-btn")
      ) {
        toggleDropDown();
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [toggleDropDown]);

  const handleLogout = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleDropDown();
  };

  return (
    <ProfileDropDownStyle
      ref={dropdownRef}
      className="shadow-lg rounded-md cursor-default"
    >
      <div className="arrow shadow-lg" />
      <ul className="relative z-10 py-6 px-4 bg-white">
        <li className="p-2 mb-6 flex">
          <div
            className="w-10 h-10 rounded-full flex items-center justify-center object-cover mb-2 mr-4"
            style={{ background: "#EAE7FE" }}
          >
            <h5 className="capitalize text-[#12046D]">TB</h5>
          </div>
          <div>
            <p className="text-[#442ED0] font-medium">Tara Blake</p>
            <p className="text-[#575B68] text-xs">{org?.email}</p>
          </div>
        </li>

        <Link to="/dashboard">
          <li
            onClick={(e) => {
              e.stopPropagation();
              toggleDropDown();
            }}
            className="hoverable duration-300 p-2 cursor-pointer"
          >
            <p className="flex justify-between items-center">My Organizations</p>
          </li>
        </Link>

        <li
          className="hoverable duration-300 p-2 mt-4 cursor-pointer"
          onClick={handleLogout}
        >
          <p className="flex justify-between items-center">
            Log Out
            <Icon.Power size={16} />
          </p>
        </li>
      </ul>
    </ProfileDropDownStyle>
  );
};

export default ProfileDropDown;
